import { render, staticRenderFns } from "./DataAccessSubscriptionPacks.vue?vue&type=template&id=629acc27&scoped=true&"
import script from "./DataAccessSubscriptionPacks.vue?vue&type=script&lang=js&"
export * from "./DataAccessSubscriptionPacks.vue?vue&type=script&lang=js&"
import style0 from "./DataAccessSubscriptionPacks.vue?vue&type=style&index=0&id=629acc27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629acc27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('629acc27')) {
      api.createRecord('629acc27', component.options)
    } else {
      api.reload('629acc27', component.options)
    }
    module.hot.accept("./DataAccessSubscriptionPacks.vue?vue&type=template&id=629acc27&scoped=true&", function () {
      api.rerender('629acc27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/DataAccessSubscriptionPacks.vue"
export default component.exports